import { CONNECT_USER, CONNECT_SUCCESS } from '../actions';

export const ConnectUser = () => ({
  type: CONNECT_USER,
});

export const ConnectSuccess = (connection) => ({
  type: CONNECT_SUCCESS,
  payload: connection,
});
